import { Injectable } from '@angular/core';
import { SelectInputsList } from '@portal/shared/helpers/src';
import { ISelectInput } from '@portal/shared/ui/filter';
import { Channel } from '../../../enums/channel.enum';

import sortBy from 'lodash-es/sortBy';

@Injectable()
export class TransactionChannels extends SelectInputsList {
  keyValue = {
    [Channel.Mail]: $localize`:transaction channel|:Mail`,
    [Channel.Pos]: $localize`:transaction channel|:Point of sale`,
    [Channel.Ecom]: $localize`:transaction channel|:E-commerce`,
    [Channel.Mobile]: $localize`:transaction channel|:Phone`,
    // label only: TELE is covered by the Phone option (MOBILE + TELE), so it is not listed separately
    [Channel.Tele]: $localize`:transaction channel|:Phone`,
    [Channel.Virtual]: $localize`:transaction channel|:Virtual`,
  };
  list: ISelectInput[] = sortBy(
    this.getSelectInputs().filter(({ id }) => id !== Channel.Tele),
    ['text'],
  );

  constructor() {
    super();
  }
}
